<template>
  <div>
    <a-row :gutter="[24, 24]">
      <a-col
        :xs="{ span: 24 }"
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
        :lg="{ span: 20, offset: 2 }"
        style="margin-top: 10px"
      >
        <div class="card-container">
          <a-tabs type="card" defaultActiveKey="1" @change="callback">
            <a-tab-pane key="1" tab="Genes">
              <a-row style="margin-top: 5px">
                <a-col :span="24">
                  <geneTable />
                </a-col>
              </a-row>
            </a-tab-pane>
          </a-tabs>
        </div>
      </a-col>
    </a-row>
  </div>
</template>
<script>
import geneTable from "./gene_table.vue";

export default {
  components: { geneTable },
  methods: {
    goto(value) {
      this.$message.success(value);
    },
  },
  data() {
    return {
      formLayout: "horizontal",
      customStyle:
        "background: #f7f7f7;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden;font-size:25px;line-height:25px",
    };
  },
};
</script>
<style scpoed>
.h1 {
  font-size: 40px;
  font-weight: bolder;
}
.keyword-lighten {
  color: #000;
  background-color: #ffff00;
}
.downloadbutton {
  background-color: aqua;
  border-color: black;
  padding: 3px 3px;
}
.card-container {
  background: #f5f5f5;
  overflow: hidden;
  padding: 4px;
}
</style>
